import { hackensackConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function HackensackPage() {
  return <CityPageTemplate config={hackensackConfig} />;
}